module.exports = __webpack_public_path__ + "static/media/redis.26567d79.png";